import React from 'react';
import PropTypes from 'prop-types';
import SharedPropsContext from '../../contexts/SharedProps';

const BackgroundImageSection = ({ backgroundImage }) => {
  const { lowEnd, prefix } = React.useContext(SharedPropsContext);

  return (
    <div className="hero-image-bg">
      <div
        data-aload={!lowEnd}
        className="hero-image-bg-original"
        style={{ backgroundImage: `url(${prefix}${backgroundImage.original})` }}
      />
    </div>
  );
};

BackgroundImageSection.propTypes = {
  backgroundImage: PropTypes.shape({
    original: PropTypes.string.isRequired,
  }).isRequired,
};

export { BackgroundImageSection };
